import { FaInfoCircle } from 'react-icons/fa'
import { Tooltip } from '@outbound-ai/ursa'
import { DataX } from '@outbound-ai/ursa'
import { PositionEnum } from 'types/cssTypes'
interface IProps {
  details: any
  title: string
}

export const PostCallEntities = ({ details, title }: IProps) => {
  const hasExtractedData = details.some((el: { value: any }) => el.value)
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  })
  return (
    <div className="call-details-extra-group">
      <div className="title">{title} </div>
      {hasExtractedData ? (
        details.map((detail: any) => {
          return detail.value ? (
            <div key={detail.label}>
              <div className="call-detail">
                {detail.infoText ? (
                  <>
                    <div className="call-detail-label">
                      <span>
                        {detail.label}{' '}
                        <Tooltip
                          className="text-with-tooltip"
                          tooltipText={detail.infoText}
                          position={PositionEnum.top}
                          positionContent={-20}
                          positionTooltipArrow={10}
                          tooltipStyles={{
                            'max-width': '20rem',
                            width: '20rem',
                            transform: 'translateY(15%) translateX(-7%)',
                          }}
                          hideTimeout={0}
                        >
                          <FaInfoCircle />
                        </Tooltip>
                      </span>
                    </div>
                    <div>
                      {detail.currency ? (
                        <span className="call-detail-value">
                          <DataX
                            value={formatter.format(detail.value)}
                            type={detail.hasMatch ? (detail.doValueMatch ? 'success' : 'warning') : 'default'}
                            noHover={true}
                          />
                        </span>
                      ) : (
                        <span className="call-detail-value">
                          <DataX
                            value={detail.value}
                            type={detail.hasMatch ? (detail.doValueMatch ? 'success' : 'warning') : 'default'}
                            noHover={true}
                          />
                        </span>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="call-detail-label">{detail.label}</div>
                    <div>
                      {detail.currency ? (
                        <span className="call-detail-value">
                          <DataX
                            value={formatter.format(detail.value)}
                            type={detail.hasMatch ? (detail.doValueMatch ? 'success' : 'warning') : 'default'}
                            noHover={true}
                          />
                        </span>
                      ) : (
                        <span className="call-detail-value">
                          <DataX
                            value={detail.value}
                            type={detail.hasMatch ? (detail.doValueMatch ? 'success' : 'warning') : 'default'}
                            noHover={true}
                          />
                        </span>
                      )}
                    </div>
                  </>
                )}
              </div>
              {detail.hasMatch && !detail.doValueMatch && detail.slot != 'claim_status_payer' ? (
                <span className="warning">
                  Does not match
                  {detail.currency ? (
                    <> Provider Bill Amount : {formatter.format(detail.providerValue)}</>
                  ) : (
                    <>
                      {' '}
                      Provider {detail.label}: {detail.providerValue}
                    </>
                  )}
                </span>
              ) : (
                ''
              )}
            </div>
          ) : (
            ''
          )
        })
      ) : (
        <div className="no-data-extracted">No Data Extracted</div>
      )}
    </div>
  )
}
